import { eleveSchema } from '../../../../types/user/eleve.def';
import { MESSAGES } from '../../../../helpers/messages';
import { createOptionsTypes } from '../../../../types/user/createUserMutation.def';
import { GET_PROF_DASHBOARD } from '../../../query/dashboardProf/dashboardQuery';
import toast from 'react-hot-toast';

export const createUserMutationOptions = ({ setForm }: createOptionsTypes) => ({
  refetchQueries: [{ query: GET_PROF_DASHBOARD }, 'GetProfDashboard'],
  onCompleted: data => {
    const firstname =
      data?.createUsersPermissionsUser?.data?.attributes?.firstname;
    toast.success(MESSAGES.sucess.addUser(firstname));
    setForm &&
      setForm({
        ...eleveSchema
      });
  },
  onError: e => {
    const message = MESSAGES.error.mailExiste;
    toast.error(message);
  }
});
